<template>
    <div class="service">
        <Header />
        <Login />
        <div class="container">
            <div class="title_area">
                <p>주요 서비스</p>
            </div>
            <div class="cont1 cont">
                <p class="title">아튜브리그란?</p>
                <p>프로작가로의 데뷔를 위한 공간으로 아튜브 회원은 누구나 작품을 등록할 수 있습니다. 각 작품의 매월에 발생한 별점과 조회수를 바탕으로<br> 이달의 베스트 전당에 게시됩니다. 또한 아튜브 리그 내의 작품 중 별점, 조회수, 별점 참여자 수와 재미, 상업성, 완성도 등을 고려하여 정식 연재의 기회를 드립니다</p>
            </div>
            <div class="cont2 cont">
                <p class="title">작품/회차 검수 절차</p>
                <p>모든 작품, 회차는 등록,수정 시 2~3일 정도의 검수 날짜가 소요되며 (당사 사정에 따라 변동 될 수 있습니다) 검수 이후 통과된 작품만<br> 다른 사용자에게 보일 수 있도록 게시됩니다. 작품 정보 수정의 경우는 검수 기간 동안 수정 부분만 비공개 되는 것이 아닌 해당 작품 전체가 비공개 됩니다.</p>
            </div>
            <div class="state">
                <div class="white_state">
                    <img src="../assets/images/clock.svg" />
                    <p class="name">대기상태</p>
                    <p>저장만 한 경우로 등록 신청 전 상태이며 수정과 삭제가 가능합니다.</p>
                </div>
                <img src="../assets/images/icon_right_arrow.svg" class="arrow"/>
                <div class="gray_state">
                    <img src="../assets/images/eye.svg" />
                    <p class="name">검수 중 상태</p>
                    <p>수정과 삭제가 불가능합니다.</p>
                </div>
                <img src="../assets/images/Line_icon.svg" class="line"/>
                <div class="gray_state three">
                    <img src="../assets/images/hand.svg" />
                    <p class="name">보류</p>
                    <p>운영 원칙 위반으로 게시 불가 상태이며 작품/회차를 수정 후 다시 신청하여 게시 가능합니다.</p>
                </div>
                <img src="../assets/images/icon_right_arrow.svg" class="arrow"/>
                <div class="purple_state">
                    <img src="../assets/images/complete_check.svg" />
                    <p class="name">완료</p>
                    <p>플랫폼에 노출됩니다.</p>
                </div>
            </div>
            <div class="cont3 cont">
                <p class="title">성인 등급 기준</p>
                <table>
                    <th>구분</th>
                    <th>선정성</th>
                    <th>폭력성</th>
                    <th>언어</th>
                    <th>범죄 및 약물</th>
                    <th>기타</th>
                    <tr class="mid">
                        <td>성인</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                    </tr>
                    <tr>
                        <td>전연령</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                        <td>신체 묘사 중 노출도와 성기와 가슴등의 구체적인 묘사 등 (노골적으로 특정 신체 부위를 부각 할 수 있는 장면 포함. 단 직접적인 성기묘사 금지) 동성,이성간 성행위와 유사 성행위, 자위 및 변태성행위와 성범죄 등의 내용을 구체적으로 묘사</td>
                    </tr>
                </table>
            </div>
            <div class="cont4 cont">
                <p class="title">게시 불가 기준</p>
                <p>· 게시판 성격에 맞지 않거나 동일한 게시물을 반복적 도배하는 경우</p>
                <p>· 내용 없는 그림을 등록하여 서비스 내 공정한 경쟁을 해치는 경우</p>
                <p>· 개인적인 비난, 비판, 토론 형태를 갖는 게시물의 경우</p>
                <p>· 스팸글, 홍보글 등의 도배자료를 올리는 경우</p>
                <p>· 주민등록생성기, 카드생성기, 아이템생성기 등 불법자료를 올리는 경우</p>
                <p>· 불법제품을 이용자에게 판매하거나 소개하는 경우</p>
                <p>· 불법적인 해킹이나 바이러스를 유포하는 행위</p>
                <p>· 운영자, 직원 및 관계자 사칭하는 경우</p>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Login from '../components/Login.vue'

export default {
    name: 'Service',
        pageCategory: '',
        components: {
            Header,
            Footer,
            Login,
    }
}
</script>